//nuitaLHotel.js

import React from 'react';
import Particles from 'react-particles';
//import {loadFull} from 'tsparticles';
import { useCallback } from 'react';
import { loadSlim } from "tsparticles-slim";
import pdf from './cv/tn_report_master.pdf';
import './projet.css';

function Stage2a() {
      const profil = require('./image/profil.PNG');
      const form = require('./image/form.PNG');
      const login = require('./image/login.PNG');
      const compare = require('./image/compare.PNG');
      const train = require('./image/train.PNG');

      const particlesInit = useCallback(async engine => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        //await loadFull(engine);
        await loadSlim(engine);
      }, []);
  
      const particlesLoaded = useCallback(async container => {
          await console.log(container);
      }, []);

      return (
      <div className='flex'>
        <a href="/" className='back'>Back to Main Page</a>
        <h1>Development of a DAX30 Prediction Application</h1>
        <p className='center'><i>Develop with JavaScript</i></p>
        <div className='download'><a href={pdf}>Download the report</a></div>
      <div className="paragraph-container">
        <h3>Problematic</h3>
        <p>The main issue of this project is the development of an application that implements various trading prediction methods and strategies. Currently, trading-related transactions reach 6.6 trillion dollars per day, with a significant portion attributed to algorithmic trading and high-frequency trading, representing 50% to 75% of the total trading volume. The emergence of AI-based models, such as artificial neural networks, is a recent trend in this field dominated by statistical models.</p>

        <h3>Conception</h3>
        <p>The design of this project involves using several technologies to create a dynamic and interactive web application. The key technologies used are:</p>
        <p><strong>React :</strong> An open-source JavaScript library developed by Facebook, enabling the creation of dynamic user interfaces. It promotes clear organization and simplified code maintenance through a modular approach to components.</p>
        <p><strong>Flask :</strong> A micro-framework in Python for web development, used to create the application's backend API. It facilitates the management of user data, ensuring authenticity and integrity of information.</p>
        <p><strong>SQLite3 :</strong> A relational database management system used for storing and managing application data.</p>
        <p><strong>Plotly :</strong> A graphical library for Python that enables the creation of interactive data visualizations, integrated into the application to represent the results of predictions and Brownian movements.</p>
        <p>The application architecture includes authentication pages, user profiles, administration, and interfaces for training and visualizing prediction algorithms. Design choices focus on usability and security, with particular attention to user management and visual customization of the interface.</p>

        <div className="columns">
        <div className="column_image">
        <img src={profil} alt="profile_screen" />
        <div className="image-caption"><i>Profile page where the user finds their own training.</i></div>
        </div>

        <div className="column_image">
        <img src={form} alt="form_screen" />
        <div className="image-caption"><i>Example of a form for MLP regressor.</i></div>
        </div>

        <div className="column_image">
        <img src={login} alt="login_screen" />
        <div className="image-caption"><i>Login page.</i></div>
        </div>

        <div className="column_image">
        <img src={compare} alt="compare_screen" />
        <div className="image-caption"><i>Example of two training sessions placed side by side to compare their results.</i></div>
        </div>

        <div className="column_image">
        <img src={train} alt="train_screen" />
        <div className="image-caption"><i>Training page displaying the graphics after training. The form is located below.</i></div>
        </div>
        </div>

        <div className="columns">
        <div className="column">
            <h4>Supervisors</h4>
            <ul>
                <li>Mario Lezoche, Ph. D.</li>
                <li>Philippe Kalitine</li>
            </ul>
        </div>
        <div className="column">
            <h4>AI Developer</h4>
            Guillaume Bourgeon
        </div>
        <div className="column">
            <h4>Web Developer</h4>
            Thibault Boisseau
        </div>
        </div>
        </div>
        <div className='particles-container'>
      <Particles 
        id="tsparticles"
        init={particlesInit}
        loaded={particlesLoaded}
        options={{
            background: {
                color: {
                    value: "#0d47a1",
                },
            },
            fpsLimit: 120,
            interactivity: {
                events: {
                    onClick: {
                        enable: true,
                        mode: "push",
                    },
                    onHover: {
                        enable: true,
                        mode: "repulse",
                    },
                    resize: true,
                },
                modes: {
                    push: {
                        quantity: 4,
                    },
                    repulse: {
                        distance: 200,
                        duration: 0.4,
                    },
                },
            },
            particles: {
                color: {
                    value: "#ffffff",
                },
                links: {
                    color: "#ffffff",
                    distance: 150,
                    enable: true,
                    opacity: 0.5,
                    width: 1,
                },
                move: {
                    direction: "none",
                    enable: true,
                    outModes: {
                        default: "bounce",
                    },
                    random: false,
                    speed: 6,
                    straight: false,
                },
                number: {
                    density: {
                        enable: true,
                        area: 800,
                    },
                    value: 80,
                },
                opacity: {
                    value: 0.5,
                },
                shape: {
                    type: "circle",
                },
                size: {
                    value: { min: 1, max: 5 },
                },
            },
            detectRetina: true,
        }}
      />
      </div>
    </div>
    );
  }
  
  export default Stage2a;
